import EntertainmentBoard from '~/components/EntertainmentBoard/EntertainmentBoard';
import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import { useTranslation } from 'react-i18next';
import { Content, List, Root } from '@radix-ui/react-tabs';
import CustomTrigger from '~/ui/CustomTrigger/CustomTrigger';
import { useState } from 'react';
import styles from './Entertainment.module.scss';
import RecordsBoard from '~/components/Entertainment/RecordsBoard/RecordsBoard';

const ACTIVE_TABS = {
  SLOTS: 'slots',
  RECORDS: 'records',
};

const Entertainment = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(ACTIVE_TABS.SLOTS);
  return (
    <Page heading={<Heading text={t('services')} />}>
      <Root value={activeTab} onValueChange={value => {setActiveTab(value)}} className={styles.root}>
        <List className={styles.tabsList}>
          <CustomTrigger key={ACTIVE_TABS.SLOTS} value={ACTIVE_TABS.SLOTS} title={t('slots')} activeTab={activeTab} />
          <CustomTrigger key={ACTIVE_TABS.RECORDS} value={ACTIVE_TABS.RECORDS} title={t('records')} activeTab={activeTab} />
        </List>
        <Content value={ACTIVE_TABS.SLOTS}>
          <EntertainmentBoard />
        </Content>
        <Content value={ACTIVE_TABS.RECORDS}>
          <RecordsBoard />
        </Content>
      </Root>
    </Page>
  );
};

export default Entertainment;
